import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { defaultSuccess } from "../../../libs/utils";
import { USER_ACTIONS } from "../../../redux/auth/actions";
import { PREFERENCES_ACTIONS } from "../../../redux/preferences/actions";
import {
  selectCompany,
  selectCompanyRegistration
} from "../../../redux/preferences/selectors";
import {
  createRegistrationSafetyQuestionAnswers,
  getRegistrationSafetyQuestionAnswers,
  getRegistrationSafetyQuestions
} from "../../../services/api/registrations";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import CompanySecurityQuestionsForm from "./CompanySecurityQuestionsForm";

class _CompanySecurityQuestions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      securityQuestions: [],
      answers: [],
      answersLoaded: false,
      isCreating: false
    };

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    registration: PropTypes.object,
    setPreference: PropTypes.func,
    getDataRequest: PropTypes.func,
    company: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    getRegistrationSafetyQuestions(this.props.registration.id, {
      "page[size]": 50
    }).then(response => {
      this.setState({
        securityQuestions: response.data
      });
    });

    getRegistrationSafetyQuestionAnswers(this.props.registration.id, {
      "page[size]": 50
    }).then(response => {
      this.setState({
        answers: response.data,
        answersLoaded: true
      });
    });
  }

  _handleSubmit(values) {
    let promisses = [];
    Object.entries(values).forEach(value => {
      promisses.push(
        createRegistrationSafetyQuestionAnswers(this.props.registration.id, {
          answer: value[1],
          safetyQuestionId: value[0].split("_")[1]
        })
      );
    });

    Promise.all(promisses).then(responses => {
      defaultSuccess(
        "Thank you for updating your safety questions, please wait while we reload all you settings."
      );
      window.setTimeout(window.location.reload.bind(window.location), 3000);
    });
  }

  render() {
    const {
      securityQuestions,
      answers,
      answersLoaded,
      isCreating
    } = this.state;

    return [
      <AdminSubHeader
        title="Safety Questions"
        key="subheader"
        breadcrumbs={[]}
      />,
      <div className="m-content" key="content">
        {securityQuestions.length > 0 && answersLoaded && (
          <CompanySecurityQuestionsForm
            onSubmit={this._handleSubmit}
            questions={securityQuestions}
            answers={answers}
            formSubmitting={isCreating}
          />
        )}
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  setPreference: (key, value) =>
    dispatch(PREFERENCES_ACTIONS.setPreference(key, value)),
  getDataRequest: () => dispatch(USER_ACTIONS.getDataRequest())
});

const mapStateToProps = function(state) {
  return {
    registration: selectCompanyRegistration(state),
    company: selectCompany(state)
  };
};

const CompanySecurityQuestions = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_CompanySecurityQuestions)
);

export default CompanySecurityQuestions;
